<template>
    <router-link :to="pfLink" class="tr clickable">
        <div class="td">{{ portfolio.name }}</div>
        <a class="td td-collapse text-black hover_text-green" @click.stop target="_blank" :href="`https://docs.google.com/spreadsheets/d/${portfolio.spreadsheetKey}`"><span class="material-icons valign-middle text-20px">open_in_new</span></a>
        <div class="td td-collapse text-black hover_text-red" @click.prevent="deletePortfolio"><span class="material-icons valign-middle text-20px">remove_circle_outline</span></div>
    </router-link>
</template>

<script>
export default {
    props:{
        portfolio: Object,
    },
    computed:{
        pfLink(){
            const spreadsheetTab = this.portfolio.spreadsheetTab || 1
            return `/portfolio/${this.portfolio.spreadsheetKey}/${spreadsheetTab}`
        }
    },
    methods:{
        deletePortfolio(){
            if(!confirm('Are you sure you want to delete this portfolio?')){
                return
            }
            const portfolios = JSON.parse(localStorage.getItem('portfolios') || '[]')

            const toDeleteIndex = portfolios.findIndex(x => x.name == this.portfolio.name)
            portfolios.splice(toDeleteIndex, 1)

            localStorage.setItem('portfolios', JSON.stringify(portfolios))
            this.$emit('deleted')
        }
    }
}
</script>